"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _helpers = require("../helpers");
var _Text = _interopRequireDefault(require("./Text"));
var _excluded = ["hoverColor"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var propTypes = {
  /** Color of the link. Will default to "focus" */
  color: _propTypes["default"].string,
  /** Color when link is hovered. Will default to "focus" */
  hoverColor: _propTypes["default"].string
};
var LinkSC = (0, _styledComponents["default"])(_Text["default"]).attrs(function (props) {
  return {
    as: props.as || "a"
  };
}).withConfig({
  displayName: "Link__LinkSC",
  componentId: "sc-1ypmfpf-0"
})(["display:inline-block;color:", ";text-decoration:none;&:hover,&:focus{color:", ";cursor:pointer;}"], function (props) {
  return (0, _helpers.getColor)(props, "color", "focus");
}, function (props) {
  return (0, _helpers.getColor)(props, "$hoverColor", "focus");
});
var Link = function Link(_ref) {
  var hoverColor = _ref.hoverColor,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(LinkSC, _extends({
    $hoverColor: hoverColor
  }, props));
};
Link.propTypes = propTypes;
var _default = Link;
exports["default"] = _default;